export default {"src":"/_next/static/media/document.84a6a377.svg","height":61,"width":60};